import {
  PageWrap,
  Section,
  Title,
  Subtitle,
  H2,
  H3,
  P,
  Ul,
  Ornament,
} from "./CookiesPageStyles";

export default function CookiesPage() {
  return (
    <PageWrap>
      <Ornament />

      <Section>
        <Title>Politica de Cookies</Title>
        <Subtitle>
          Informații despre modul în care Ahava Cakes folosește cookie-uri
          pentru funcționarea site-ului și îmbunătățirea experienței online.
        </Subtitle>
      </Section>

      <Section>
        <H2>1. Ce sunt cookie-urile?</H2>
        <P>
          Cookie-urile sunt fișiere mici salvate pe dispozitivul tău atunci când
          vizitezi un site. Acestea ajută site-ul să funcționeze corect, să
          rețină anumite preferințe și să îmbunătățească experiența de navigare.
        </P>
      </Section>

      <Ornament />

      <Section>
        <H2>2. De ce folosim cookie-uri?</H2>
        <P>
          Ahava Cakes folosește cookie-uri pentru ca site-ul să poată funcționa
          în mod corect, pentru gestionarea coșului, autentificare, plasarea
          comenzilor și pentru îmbunătățirea experienței utilizatorilor.
        </P>
      </Section>

      <Section>
        <H2>3. Tipuri de cookie-uri folosite</H2>

        <H3>Cookie-uri necesare</H3>
        <P>
          Aceste cookie-uri sunt esențiale pentru funcționarea site-ului și nu
          pot fi dezactivate din sistemele noastre.
        </P>
        <Ul>
          <li>memorarea produselor adăugate în coș;</li>
          <li>funcționarea paginilor de autentificare și înregistrare;</li>
          <li>plasarea comenzilor online;</li>
          <li>securitatea și stabilitatea site-ului.</li>
        </Ul>

        <H3>Cookie-uri de analiză</H3>
        <P>
          Acestea ne pot ajuta să înțelegem cum este folosit site-ul, ce pagini
          sunt accesate și cum putem îmbunătăți experiența online.
        </P>
        <Ul>
          <li>analiza traficului pe site;</li>
          <li>identificarea paginilor populare;</li>
          <li>optimizarea conținutului și a experienței utilizatorului.</li>
        </Ul>

        <H3>Cookie-uri de marketing</H3>
        <P>
          Aceste cookie-uri pot fi folosite pentru afișarea unor reclame sau
          campanii mai relevante pentru utilizatori.
        </P>
        <Ul>
          <li>campanii de remarketing;</li>
          <li>măsurarea performanței reclamelor;</li>
          <li>personalizarea comunicării comerciale.</li>
        </Ul>
      </Section>

      <Section>
        <H2>4. Consimțământul tău</H2>
        <P>
          La prima accesare a site-ului, poți accepta sau respinge utilizarea
          cookie-urilor. Pentru anumite funcționalități importante, precum
          înregistrarea unui cont sau plasarea unei comenzi, acceptarea
          cookie-urilor poate fi necesară.
        </P>
      </Section>

      <Section>
        <H2>5. Gestionarea cookie-urilor</H2>
        <P>
          Poți modifica sau șterge cookie-urile din setările browserului tău.
          Totuși, dezactivarea anumitor cookie-uri poate afecta funcționarea
          corectă a site-ului.
        </P>
      </Section>

      <Section>
        <H2>6. Contact</H2>
        <P>
          Pentru întrebări legate de politica de cookies, ne poți contacta prin
          datele disponibile pe pagina de contact Ahava Cakes.
        </P>
      </Section>

      <Ornament />
    </PageWrap>
  );
}
